import React from 'react'

export default function CampaignInfluencerSidebarShell({
  auth,
  HeaderComponent,
  NavComponent,
  PageComponent,
  className = '',
}) {
  return (
    <div className={`fixed top-0 right-0 w-[600px] h-full z-20 flex flex-col shadow ${className}`}>
      <HeaderComponent auth={auth} />
      <NavComponent />
      <PageComponent auth={auth} />
    </div>
  )
}
